import React, { useEffect } from 'react';
import '../styles/toast.css';

function Toast({ message, onClose }) {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 2000);

    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div className="toast">
      <div className="toast-icon">✓</div>
      <div className="toast-message">{message}</div>
    </div>
  );
}

export default Toast;